/**
 * StatBadge
 * Shows a small red "STAT" chip on prescriptions carrying a medicine ordered stat (immediately).
 * Used in: Active Dispenses list.
 * Props: { show: boolean }
 */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { IPD_COLORS } from '../theme';
import { invChipSx } from './StatusChip';

export default function StatBadge({ show }) {
  if (!show) return null;

  return (
    <Tooltip title="Contains a STAT (immediate) order" arrow>
      <Chip
        label="STAT"
        size="small"
        sx={{
          ...invChipSx({ color: IPD_COLORS.error.text, variant: 'solid', size: 'xs' }),
          cursor: 'default',
        }}
      />
    </Tooltip>
  );
}
